import script from "./MapVietNamComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MapVietNamComponent.vue?vue&type=script&setup=true&lang=js"

import "./MapVietNamComponent.vue?vue&type=style&index=0&id=707764e2&lang=css"

const __exports__ = script;

export default __exports__